import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle } from './nextVideoItem.style';
import { SELECTED_SIGNAL } from '../../../tornado/signals';
import Poster from '../../../tornado/poster/poster.component';

export class NextVideoItem extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Poster: {
          type: Poster,
          passSignals: {
            [SELECTED_SIGNAL]: true,
          },
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  set item(value) {
    this.tag('Poster').item = value;
  }

  set label(value) {
    this.tag('Label').text.text = value;
  }

  _getFocused() {
    return this.tag('Poster');
  }
}
